import type { StepConfigParams } from '@flows/configs/types'

export const NATIVE_TITLE_SIZE = 'h3'

export const v2InfoNoteHeading = <TKey extends string>(key: TKey) =>
  ({ type: 'text', text: v2Text(key), weight: 'bold', emphasis: 'default' }) as const

export const v2InfoNoteText = <TKey extends string>(key: TKey) =>
  ({
    type: 'text',
    text: v2Text(key),
    style: 'caption',
    color: 'grey700',
    emphasis: 'default',
  }) as const

export const v2Text = <TKey extends string>(key: TKey) =>
  ({ type: 'translatableText', translationKey: `sharedFlows_petHealthV2:${key}` }) as const

export const v2InfoModal = <TKey extends string>(keyPrefix: TKey) =>
  ({
    backdrop: 'blur',
    modalConfiguration: [
      { type: 'title', text: v2Text(`${keyPrefix}.infoTitle`), isSmall: true },
      { type: 'text', text: v2Text(`${keyPrefix}.info`) },
    ],
  }) as const

export const v2TextWithPetName = <TKey extends string>(params: StepConfigParams, key: TKey) =>
  ({
    ...v2Text(key),
    values: {
      pet_name: { type: 'dynamicValue', path: params.helperFunctions.getParamPath('pet_name') },
    },
  }) as const

export const v2ContinueFooter = (platform: 'native' | 'web') =>
  platform === 'native'
    ? ({
        footer: {
          defaultButton: {
            buttonLabel: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.buttons.continue',
            },
          },
        },
      } as const)
    : {}

export const v2PetPortrait = (params: StepConfigParams) =>
  ({ type: 'avatar', srcPath: params.helperFunctions.getTransientPath('pet_portrait') }) as const
